export class LocationData {
    latitude: string;
    longitude: string;
    name: string;
    vicinity: string;
    codePostal: string;
    country: string;
}
